import { FC, useEffect, useState } from 'react';

import LinkForm from './components/LinkForm';
import LinkModal from './components/LinkModal';

import './LinkPage.scss';

const LinkPage: FC = () => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const toggleModal = () => setIsModalOpen(!isModalOpen);

  useEffect(() => {
    document.body.classList.add('LinkPage');
    return () => {
      document.body.classList.remove('LinkPage');
    };
  }, []);

  return (
    <div className="link-page-content">
      <LinkForm onShowInfoClick={setIsModalOpen} />
      <LinkModal isOpen={isModalOpen} onClose={toggleModal} />
    </div>
  );
};

export default LinkPage;
